module.exports = __webpack_public_path__ + "static/media/may.72c50d00.jpeg";